import React from "react";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Alert,
} from "@mui/material";
import { useGetAllStudiesQuery } from "../../api/useGetAllStudies";
const StudyDropDown = ({ selectedStudy, handleStudyChange }) => {
  const { data, isLoading, isError, error } = useGetAllStudiesQuery();

  if (isLoading) {
    return <div>loading...</div>;
  }
  if (isError) {
    return <Alert severity="error">{error.response.data.error}</Alert>;
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="study-select-label">스터디 선택</InputLabel>
      <Select
        labelId="study-select-label"
        value={selectedStudy}
        label="스터디 선택"
        onChange={handleStudyChange}
      >
        {data.map((study) => (
          <MenuItem key={study._id} value={study}>
            {study.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StudyDropDown;
